export default __webpack_public_path__ + "static/media/property_901.e395af4b.png";